import React from "react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";
import { CLIENTS } from "../lib/constants";

const LogoItem = ({ c }) => (
  <div
    data-testid={`client-logo-${c.name}`}
    className="group mx-6 flex h-24 w-40 shrink-0 items-center justify-center rounded-2xl border border-white/5 bg-white/[0.02] px-6 transition-colors duration-300 hover:border-white/20"
    title={c.name}
  >
    <img
      src={c.logo}
      alt={c.name}
      loading="lazy"
      className="max-h-14 max-w-[110px] object-contain opacity-50 grayscale transition-[filter,opacity] duration-500 group-hover:opacity-100 group-hover:grayscale-0"
    />
  </div>
);

export const Clients = () => {
  const { t } = useLang();
  const loop = [...CLIENTS, ...CLIENTS];

  return (
    <section
      id="clientes"
      data-testid="clients-section"
      className="relative py-24 md:py-32 border-t border-white/10"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 text-center">
        <Reveal>
          <span className="font-mono-wt text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#0047ff]">
            {t.clients.overline}
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
            {t.clients.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-5 max-w-xl text-base md:text-lg font-light text-zinc-400">
            {t.clients.subtitle}
          </p>
        </Reveal>
      </div>

      {/* Marquee */}
      <Reveal delay={0.15} className="marquee-track relative mt-14 overflow-hidden">
        {/* edge fades */}
        <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-24 bg-gradient-to-r from-[#050507] to-transparent" />
        <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-24 bg-gradient-to-l from-[#050507] to-transparent" />
        <div className="flex w-max animate-marquee">
          {loop.map((c, i) => (
            <LogoItem key={`${c.name}-${i}`} c={c} />
          ))}
        </div>
      </Reveal>
    </section>
  );
};
